"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthenticationProvider = void 0;

var _loginResponse = require("./response-parsers/login-response");

var _isValidTokenResponse = require("./response-parsers/is-valid-token-response");

var _getCurrentUserRolesResponse = require("./response-parsers/get-current-user-roles-response");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AuthenticationProvider =
/*#__PURE__*/
function () {
  function AuthenticationProvider(securityClient) {
    _classCallCheck(this, AuthenticationProvider);

    this._securityClient = securityClient;
  }

  _createClass(AuthenticationProvider, [{
    key: "logon",
    value: function logon(username, password) {
      return this._securityClient.request({
        methodName: 'Logon',
        data: {
          LoginName: username,
          Password: password
        },
        parseResponseDelegate: _loginResponse.createLogonResponse
      });
    }
  }, {
    key: "listRoles",
    value: function listRoles() {
      return this._securityClient.request({
        methodName: 'GetCurrentUserRoles',
        parseResponseDelegate: _getCurrentUserRolesResponse.getCurrentUserRolesResponse
      });
    }
  }, {
    key: "keepAlive",
    value: function keepAlive() {
      return this._securityClient.request({
        methodName: 'IsValidToken',
        data: {
          DoNotRenewToken: 0
        },
        parseResponseDelegate: _isValidTokenResponse.createIsValidTokenResponse
      });
    }
  }]);

  return AuthenticationProvider;
}();

exports.AuthenticationProvider = AuthenticationProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/security/authentication/AuthenticationProvider.js
// module id = 213
// module chunks = 0